var React = require('react');

function OwnerUser (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"id":"Rectangle_1655","data-name":"Rectangle 1655","width":"16","height":"16","fill":"none","key":0}),React.createElement("path",{"id":"Icon_material-person-outline","data-name":"Icon material-person-outline","d":"M11.983,7.421a1.57,1.57,0,1,1-1.57,1.57,1.57,1.57,0,0,1,1.57-1.57m0,6.73c2.221,0,4.562,1.092,4.562,1.57v.823H7.421v-.823c0-.479,2.341-1.57,4.562-1.57m0-8.151a2.991,2.991,0,1,0,2.991,2.991A2.991,2.991,0,0,0,11.983,6Zm0,6.73c-2,0-5.983,1-5.983,2.991v2.243H17.965V15.722C17.965,13.733,13.979,12.73,11.983,12.73Z","transform":"translate(-4 -4)","key":1})]);
}

OwnerUser.defaultProps = {"id":"Owner_user","data-name":"Owner / user","width":"16","height":"16","viewBox":"0 0 16 16"};

module.exports = OwnerUser;

OwnerUser.default = OwnerUser;
